export default function getRestService({ session, uri }) {
  return {
    isValidSession: () => {
      if (session && session.isValid) {
        return session.isValid();
      }
      return session && !!session.jwt;
    },
    createHeaders: function () {
      const headers = new Headers();

      /* istanbul ignore else */
      if (session.jwt !== 'anon') {
        if (session.authType === 'Bearer') {
          headers.append(
            'Authorization',
            this.isValidSession() ? 'Bearer ' + session.jwt : null,
          );
        } else {
          headers.append(
            'Authorization',
            this.isValidSession() ? `${session.jwt}` : null,
          );
        }
      }

      headers.append('content-type', 'application/json');
      return headers;
    },
    sendRequest: function (path, options) {
      /* istanbul ignore else */
      if (uri) {
        return fetch(`${uri}${path}`, {
          headers: this.createHeaders(),
          credentials: session.authType !== 'Bearer' ? 'include' : undefined,
          ...options,
        });
      }
      return null;
    },
  };
}
